var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.831 0.893258C11.2827 0.827142 10.8334 1.28104 10.8334 1.83333V8.16666C10.8334 8.71895 11.2811 9.16666 11.8334 9.16666H18.1667C18.719 9.16666 19.1729 8.71737 19.1068 8.16905C19.0161 7.41738 18.8233 6.67999 18.5324 5.97763C18.1136 4.96659 17.4998 4.04793 16.7259 3.27411C15.9521 2.50028 15.0335 1.88646 14.0224 1.46767C13.32 1.17674 12.5827 0.983896 11.831 0.893258ZM17.4401 11.831C17.5062 11.2826 17.0523 10.8333 16.5 10.8333H10.1667C9.61443 10.8333 9.16671 10.3856 9.16671 9.83333V3.5C9.16671 2.94771 8.71739 2.49381 8.16908 2.55992C6.87421 2.71606 5.62913 3.17465 4.53696 3.90442C3.16655 4.8201 2.09845 6.12158 1.46772 7.6443C0.836985 9.16702 0.671957 10.8426 0.9935 12.4591C1.31504 14.0756 2.10872 15.5604 3.27415 16.7259C4.43959 17.8913 5.92445 18.685 7.54096 19.0065C9.15747 19.3281 10.833 19.1631 12.3557 18.5323C13.8785 17.9016 15.1799 16.8335 16.0956 15.4631C16.8254 14.3709 17.284 13.1258 17.4401 11.831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStatistic);
export default __webpack_public_path__ + "static/media/sidebar-statistic.e50fbaa0f1ca02413f1a247a7a81cdc7.svg";
export { ForwardRef as ReactComponent };